module.exports = __webpack_public_path__ + "static/img/3bg_11.2c004da.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/background/3bg_11.png
// module id = 687
// module chunks = 1